import { supabase } from './supabase';

const FREE_TIER_DAILY_LIMIT = 3;

export const checkAIRequestLimit = async (userId, tier) => {
  // Premium/Pro users have unlimited requests
  if (tier === 'premium' || tier === 'pro') {
    return { allowed: true, remaining: -1, requestsToday: 0, limit: -1 };
  }

  try {
    const { data, error } = await supabase
      .from('user_settings')
      .select('ai_requests')
      .eq('user_id', userId)
      .single();

    if (error) {
      console.error('Error checking request limit:', error);
      return { allowed: false, remaining: 0, requestsToday: 0, limit: FREE_TIER_DAILY_LIMIT };
    }

    if (!data?.ai_requests) {
      return { allowed: true, remaining: FREE_TIER_DAILY_LIMIT, requestsToday: 0, limit: FREE_TIER_DAILY_LIMIT };
    }

    const aiRequests = data.ai_requests;
    const lastReset = new Date(aiRequests.last_reset);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Check if we need to reset the counter (new day)
    if (lastReset < today) {
      // Reset counter for new day
      return { allowed: true, remaining: FREE_TIER_DAILY_LIMIT, requestsToday: 0, limit: FREE_TIER_DAILY_LIMIT };
    }

    // Same day - check count
    const requestsToday = aiRequests.count || 0;
    const remaining = Math.max(0, FREE_TIER_DAILY_LIMIT - requestsToday);

    return {
      allowed: remaining > 0,
      remaining,
      requestsToday,
      limit: FREE_TIER_DAILY_LIMIT
    };
  } catch (error) {
    console.error('Error in checkAIRequestLimit:', error);
    return { allowed: false, remaining: 0, requestsToday: 0, limit: FREE_TIER_DAILY_LIMIT };
  }
};

export const logAIRequest = async (userId) => {
  try {
    const { data, error: fetchError } = await supabase
      .from('user_settings')
      .select('ai_requests')
      .eq('user_id', userId)
      .single();

    if (fetchError) {
      console.error('Error fetching user requests:', fetchError);
      return;
    }

    const aiRequests = data?.ai_requests || { count: 0, last_reset: new Date().toISOString(), requests: [] };
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const lastReset = new Date(aiRequests.last_reset);

    // Reset if new day
    if (lastReset < today) {
      aiRequests.count = 0;
      aiRequests.requests = [];
      aiRequests.last_reset = new Date().toISOString();
    }

    // Increment counter and add timestamp
    aiRequests.count = (aiRequests.count || 0) + 1;
    aiRequests.requests = aiRequests.requests || [];
    aiRequests.requests.push(new Date().toISOString());

    // Update the column
    const { error: updateError } = await supabase
      .from('user_settings')
      .update({ ai_requests: aiRequests })
      .eq('user_id', userId);

    if (updateError) {
      console.error('Error logging AI request:', updateError);
    }
  } catch (error) {
    console.error('Error in logAIRequest:', error);
  }
};

